module.exports = __webpack_public_path__ + "static/img/1_04.ee1a3f13.jpg";